import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  const footerLinks = {
    内容分类: categories.slice(0, 5).map((c) => ({
      label: c.name,
      path: `/category/${c.slug}`,
    })),
    关于我们: [
      { label: '品牌介绍', path: '/about' },
      { label: '联系我们', path: '/about#contact' },
      { label: '用户口碑', path: '/about#testimonials' },
      { label: '发展历程', path: '/about#milestones' },
    ],
    热门文章: [
      { label: '2025必看国产剧', path: '/article/a001' },
      { label: '国漫技术突破', path: '/article/a002' },
      { label: '体育直播新体验', path: '/article/a003' },
      { label: '暑期综艺推荐', path: '/article/a004' },
    ],
    帮助中心: [
      { label: '常见问题', path: '/about#faq' },
      { label: '使用指南', path: '/about' },
      { label: '意见反馈', path: '/about#contact' },
      { label: '商务合作', path: '/about#contact' },
    ],
  };

  return (
    <footer className="bg-foreground-950 text-background-50" role="contentinfo">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base text-background-50 mb-4">
                {title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-300 hover:text-background-50 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-primary-500 rounded-lg flex items-center justify-center">
              <i className="ri-heart-fill text-background-50 text-sm"></i>
            </div>
            <span className="font-heading text-lg text-background-50">红桃tv</span>
          </div>

          <p className="text-sm text-foreground-400">
            &copy; {new Date().getFullYear()} 红桃tv 版权所有 | 高清视频娱乐平台
          </p>

          <div className="flex items-center gap-3">
            <a href="#" className="w-9 h-9 rounded-full bg-foreground-800/50 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微信公众号" rel="nofollow">
              <i className="ri-wechat-line text-background-50 text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-foreground-800/50 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="微博" rel="nofollow">
              <i className="ri-weibo-line text-background-50 text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-foreground-800/50 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="抖音" rel="nofollow">
              <i className="ri-tiktok-line text-background-50 text-sm"></i>
            </a>
            <a href="#" className="w-9 h-9 rounded-full bg-foreground-800/50 hover:bg-primary-500 flex items-center justify-center transition-colors cursor-pointer" aria-label="B站" rel="nofollow">
              <i className="ri-bilibili-line text-background-50 text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}